

/* wait until DOM is ready */
/* === I 111 === */
document.addEventListener("DOMContentLoaded", function (event) {
  /* === X 111 === */
  /* wait until window is loaded - all images, styles-sheets, fonts, links, and other media assets 
you could also use addEventListener() instead */
  /* === I 222 === */
  // window.onload = function() {
  /* === X 222 === */
  /* OPTIONAL - waits til next tick render to run code (prevents running in the middle of render tick) */
  /* === I 333 === */
  window.requestAnimationFrame(function () {
    /* === X 333 === */
    // ========================================================================================================================
    gsap.config({ nullTargetWarn: false });
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
    if (ScrollTrigger.isTouch !== 1) {
      ScrollTrigger.normalizeScroll(true);
      ScrollSmoother.create({
        smooth: 1.25,
        effects: true,
      });
    }
    // ========================================================================================================================
    // CURSOR

    // ========================================================================================================================
    // INSTAGRAM EMBED
    var cobaltfeed = new Instafeed({
      accessToken: InstagramToken,
      limit: 8,
      templateBoundaries: ["<%", "%>"],
      template:
        '<a class="co--home--insta-embed--a" href="<% link %>" target="_blank"><img class="lazyload co--home--insta-embed--img" title="<% caption %>" src="<% image %>" /></a>',
      after: function () {
        var elem = document.querySelector("#instafeed");
        var flkty = new Flickity(elem, {
          cellAlign: "left",
          contain: true,
          pageDots: false,
          wrapAround: true,
          prevNextButtons: false,
        });
      },
    });
    cobaltfeed.run();
    gsap.set(".co--home--insta-embed", { opacity: 0 });
    gsap.to(".co--home--insta-embed", {
      scrollTrigger: {
        trigger: ".co--home--insta-embed",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // ========================================================================================================================
    // HEADER SPACER
    let coHeaderSpacer = gsap.getProperty(".header-wrapper", "height");
    gsap.set(".co--header--spacer", { height: coHeaderSpacer });
    // ========================================================================================================================
    // HEADER
    const coStickyHeaderAni = gsap
      .from(".header-wrapper", {
        yPercent: -100,
        paused: true,
        duration: 0.3,
      })
      .progress(1);

    ScrollTrigger.create({
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1
          ? coStickyHeaderAni.play()
          : coStickyHeaderAni.reverse();
      },
    });
    // ========================================================================================================================
    // HOME HERO
    // let coHomeHeroHeaderHeight = gsap.getProperty("header", "height");
    // ===
    gsap.set(".co--home--hero--1--3--3--div", { yPercent: -100 });
    // ===
    gsap.to(".co--home--hero", {
      opacity: 1,
      duration: 1,
      ease: "power2.inOut",
    });
    // ===
    let coHomeHeroTl = gsap.timeline();
    coHomeHeroTl.to(".co--home--hero--1--3--1--seven--svg", {
      duration: 1.5,
      ease: "power2.inOut",
      yPercent: -100,
    });
    coHomeHeroTl.to(
      ".co--home--hero--1--3--1--thirty--svg",
      {
        duration: 1.5,
        ease: "power2.inOut",
        yPercent: 100,
      },
      "-=1.5"
    );
    coHomeHeroTl.to(
      ".co--home--hero--1--2",
      {
        duration: 1,
        ease: "power2.inOut",
        xPercent: -100,
        opacity: 1,
      },
      "-=1"
    );
    coHomeHeroTl.to(
      ".co--home--hero--1--3--1--colon",
      {
        duration: 1,
        ease: "power2.inOut",
        opacity: 1,
      },
      "-=1"
    );
    coHomeHeroTl.to(
      ".co--home--hero--1--3--2--2--div",
      {
        duration: 1.5,
        ease: "power2.inOut",
        xPercent: 100,
        opacity: 1,
      },
      "-=1"
    );
    coHomeHeroTl.to(
      ".co--home--hero--1--3--2--1--div",
      {
        duration: 1.5,
        ease: "power2.inOut",
        xPercent: 100,
        opacity: 1,
      },
      "-=1.4"
    );
    coHomeHeroTl.to(
      ".header-wrapper",
      {
        duration: 1,
        ease: "power2.inOut",
        opacity: 1,
      },
      "-=1.4"
    );
    coHomeHeroTl.to(
      ".co--home--hero--1--3--3--div",
      {
        duration: 1,
        ease: "power2.inOut",
        opacity: 1,
        yPercent: 0,
      },
      "-=1.4"
    );
    // =====
    gsap.to(".co--home--hero--1--3--2--1", {
      scrollTrigger: {
        trigger: ".co--home--hero--guide",
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -5,
    });
    gsap.to(".co--home--hero--1--3--2--1--img", {
      scrollTrigger: {
        trigger: ".co--home--hero--guide",
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.2,
    });
    gsap.to(".co--home--hero--1--3--2--2", {
      scrollTrigger: {
        trigger: ".co--home--hero--guide",
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -10,
    });
    gsap.to(".co--home--hero--1--3--2--2--img", {
      scrollTrigger: {
        trigger: ".co--home--hero--guide",
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.1,
    });
    // ========================================================================================================================
    // HOME SUB-HERO
    let coHomeSubHeroTimeAni = gsap.timeline();
    coHomeSubHeroTimeAni.fromTo(
      ".co--home--sub-hero--2--2--span",
      {
        xPercent: 100,
      },
      {
        ease: "power2.inOut",
        xPercent: 0,
        duration: 1,
      }
    );
    coHomeSubHeroTimeAni.fromTo(
      ".co--home--sub-hero--2--2--h2",
      {
        yPercent: -100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 0.5,
      },
      "-=0.5"
    );
    // ==========
    ScrollTrigger.create({
      trigger: ".co--home--sub-hero--2--2",
      toggleActions: "restart none none reverse",
      start: "top bottom",
      end: "top top",
      // markers: true,
      animation: coHomeSubHeroTimeAni,
    });
    // ===
    // let coHomeHeroSubHeroHeight = gsap.getProperty(".co--home--sub-hero--1--1--1--h2", "height");
    // gsap.set('.co--home--sub-hero--1--1', {height: coHomeHeroSubHeroHeight * 2});
    // ========================================================================================================================
    // HOME COLLECTION
    gsap.set(".co--collection", { opacity: 0 });
    gsap.to(".co--collection", {
      scrollTrigger: {
        trigger: ".co--collection",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // ========================================================================================================================
    // HOME SLIDER ONE
    let coHomeSliderOneCopy = document.querySelectorAll(
      ".co--home--slider-one--copy"
    );
    gsap.set(coHomeSliderOneCopy, { yPercent: 100 });
    gsap.to(coHomeSliderOneCopy, {
      scrollTrigger: {
        trigger: ".co--home--slider-one--1",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    // ===
    gsap.to(".co--home--collage--1--img", {
      scrollTrigger: {
        trigger: ".co--home--collage-div",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-20%",
    });
    // ===
    // let child = document.querySelector(`.box:nth-child(${1})`);
    let coHomeSliderOneCells = document.querySelectorAll(
      ".co--home--slider-one--2--1"
    );
    gsap.set(coHomeSliderOneCells, { opacity: 0, yPercent: 50 });
    gsap.to(coHomeSliderOneCells, {
      scrollTrigger: {
        trigger: ".co--home--slider-one--2",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1.5,
      opacity: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    // ========================================================================================================================
    // AM PM
    let coHomeAmPmTimeAni = gsap.timeline();
    coHomeAmPmTimeAni.fromTo(
      ".co--home--am-pm--1--1--span",
      {
        xPercent: 100,
      },
      {
        ease: "power2.inOut",
        xPercent: 0,
        duration: 1,
      }
    );
    coHomeAmPmTimeAni.fromTo(
      ".co--home--am-pm--1--1--1",
      {
        yPercent: -100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1,
      },
      "-=0.5"
    );
    coHomeAmPmTimeAni.fromTo(
      ".co--home--am-pm--1--1--2",
      {
        yPercent: 100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1.5,
      },
      "-=1"
    );
    // ==========
    ScrollTrigger.create({
      trigger: ".co--home--am-pm--1--1",
      toggleActions: "restart none none reverse",
      start: "top bottom",
      end: "top top",
      // markers: true,
      animation: coHomeAmPmTimeAni,
    });
    // ===
    gsap.set(".co--home--am-pm--svg", { yPercent: 100 });
    gsap.to(".co--home--am-pm--svg", {
      scrollTrigger: {
        trigger: ".co--home--am-pm--2",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1.5,
      yPercent: 0,
      ease: "power2.inOut",
    });
    // ========================================================================================================================
    // COLLAGE
    let coHomeHeroCollageMarginOne = gsap.getProperty(
      ".co--home--collage--2--2--1--2",
      "height"
    );
    let coHomeHeroCollageMarginTwo = gsap.getProperty(
      ".co--home--collage--2--2--2--2",
      "height"
    );
    gsap.set(".co--home--collage--2--2--1--2", {
      marginBottom: -coHomeHeroCollageMarginOne,
    });
    gsap.set(".co--home--collage--2--2--2--2", {
      marginBottom: -coHomeHeroCollageMarginTwo,
    });
    let coHomeHeroCollageGreater = Math.max(
      coHomeHeroCollageMarginOne,
      coHomeHeroCollageMarginTwo
    );
    gsap.set(".co--home--collage-div", {
      paddingBottom: coHomeHeroCollageGreater,
    });
    // ===
    gsap.set(".co--home--collage", { opacity: 0 });
    gsap.to(".co--home--collage", {
      scrollTrigger: {
        trigger: ".co--home--collage",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // =============
    gsap.set(".co-home-1-right", { opacity: 0 });
    gsap.to(".co-home-1-right", {
        scrollTrigger: {
            trigger: ".co-home-1-right",
            start: "top 90%",
            end: "bottom top"
        },
        opacity: 1,
        duration: 1,
        ease: "Power2.inOut"
    });
    gsap.to(".co-home-1-left-frame img", {
        scrollTrigger: {
            trigger: ".co-home-1-left",
            start: "top bottom",
            end: "bottom top",
            scrub: true
        },
        top: "-10%"
    });
    gsap.set(".co-home-1-left", { opacity: 0, x: 20 });
    gsap.to(".co-home-1-left", {
        scrollTrigger: {
            trigger: ".co-home-1-left",
            start: "top 90%",
            end: "bottom top"
        },
        opacity: 1,
        duration: 1,
        x: 0,
        ease: "Power2.inOut"
    });
    gsap.set(".co-home-1-left-frame", { opacity: 0, x: -20, y: 20 });
    gsap.to(".co-home-1-left-frame", {
        scrollTrigger: {
            trigger: ".co-home-1-left",
            start: "top 90%",
            end: "bottom top"
        },
        opacity: 1,
        duration: 1,
        x: 0,
        y: 0,
        ease: "Power2.inOut"
    });
    // ========================================================================================================================
    // HOME OUR STORY
    let coHomeOurStoryTimeAni = gsap.timeline();
    coHomeOurStoryTimeAni.fromTo(
      ".co--home--our-story--1--1--span",
      {
        xPercent: 100,
      },
      {
        ease: "power2.inOut",
        xPercent: 0,
        duration: 1,
      }
    );
    coHomeOurStoryTimeAni.fromTo(
      ".co--home--our-story--1--1--1",
      {
        yPercent: -100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1,
      },
      "-=0.5"
    );
    coHomeOurStoryTimeAni.fromTo(
      ".co--home--our-story--1--1--2",
      {
        yPercent: 100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1.5,
      },
      "-=1"
    );
    // ==========
    ScrollTrigger.create({
      trigger: ".co--home--our-story--1--1",
      toggleActions: "restart none none reverse",
      start: "bottom bottom",
      end: "top top",
      // markers: true,
      animation: coHomeOurStoryTimeAni,
    });
    // ===
    gsap.to(".co--home--our-story--2--1--1--img", {
      scrollTrigger: {
        trigger: ".co--home--our-story",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.15,
    });
    gsap.set(".co--home--our-story--2", { opacity: 0 });
    gsap.to(".co--home--our-story--2", {
      scrollTrigger: {
        trigger: ".co--home--our-story--2",
        start: "top 90%",
        end: "bottom top"
      },
      opacity: 1
    });
    // ==========
    gsap.set(".co-home-2-ani", { opacity: 0, y: 20 });
    gsap.to(".co-home-2-ani", {
      scrollTrigger: {
        trigger: ".co-home-2-content-frame",
        start: "top 80%",
        end: "bottom top"
      },
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "Power2.inOut",
      stagger: 0.15
    });
    // ==========
    gsap.set(".co-home-3", { opacity: 0 });
    gsap.to(".co-home-3", {
      scrollTrigger: {
        trigger: ".co-home-3",
        start: "top 90%",
        end: "bottom top"
      },
      opacity: 1
    });
    gsap.to(".co-home-3-blob-frame", {
      scrollTrigger: {
        trigger: ".co-home-3",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      // rotate: 30,
      y: -40,
      x: 70,
      rotateZ: "10deg"
    });
    // ===
    let coHomeOurStoryTimeAni2 = gsap.timeline();
    coHomeOurStoryTimeAni2.fromTo(
      ".co--home--our-story--3--1--span",
      {
        xPercent: 100,
      },
      {
        ease: "power2.inOut",
        xPercent: 0,
        duration: 1,
      }
    );
    coHomeOurStoryTimeAni2.fromTo(
      ".co--home--our-story--3--1--1",
      {
        yPercent: -100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1,
      },
      "-=0.5"
    );
    coHomeOurStoryTimeAni2.fromTo(
      ".co--home--our-story--3--1--2",
      {
        yPercent: 100,
      },
      {
        ease: "power2.inOut",
        yPercent: 0,
        duration: 1.5,
      },
      "-=1"
    );
    // ==========
    ScrollTrigger.create({
      trigger: ".co--home--our-story--3--1",
      toggleActions: "restart none none reverse",
      start: "bottom bottom",
      end: "top top",
      // markers: true,
      animation: coHomeOurStoryTimeAni2,
    });
    // ========================================================================================================================
    // FOOTER
    gsap.set(".co--footer--730--logo", { yPercent: 100 });
    gsap.to(".co--footer--730--logo", {
      scrollTrigger: {
        trigger: ".co--footer",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
    });
    // ========================================================================================================================
    // ========================================================================================================================
    // ========================================================================================================================
    // PDP PAGE BELOW
    // ========================================================================================================================
    // ========================================================================================================================
    // ========================================================================================================================

    // CURSOR
    const cursor = cursorDot({
      easing: 5,
    });
    // console.log(cursor.parentElement);
    cursor.over(".co--cursor--visible", "co--mouseover--visible");
    cursor.over("a", "co--mouseover--a");
    cursor.over("li", "co--mouseover--li");
    cursor.over("button", "co--mouseover--button");
    // cursor.over(".co--home--hero", {background: "#fff"});
    cursor.over(
      ".co--pdp--scroll-slider--2--1",
      "co--pdp--scroll-slider--2--1--cursor"
    );
    cursor.over(
      ".co--pdp--scroll-slider--2--2",
      "co--pdp--scroll-slider--2--2--cursor"
    );
    cursor.over(
      ".co--pdp--scroll-slider--2--3",
      "co--pdp--scroll-slider--2--3--cursor"
    );
    cursor.over(
      ".co--pdp--scroll-slider--2--4",
      "co--pdp--scroll-slider--2--4--cursor"
    );
    cursor.over(
      ".co--pdp--scroll-slider--2--5",
      "co--pdp--scroll-slider--2--5--cursor"
    );
    // ========================================================================================================================
    // SUB HERO
    let coPdpSubHeroHeight = gsap.getProperty(
      ".co--pdp--sub-hero--2--frame",
      "height"
    );
    gsap.set(".co--pdp--sub-hero", { minHeight: coPdpSubHeroHeight });

    let coPdpSubHeroAni = document.querySelectorAll(".co--pdp--sub-hero--ani");
    gsap.set(coPdpSubHeroAni, { opacity: 0 });
    gsap.to(coPdpSubHeroAni, {
      scrollTrigger: {
        trigger: ".co--pdp--sub-hero",
        start: "35% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      delay: 0.5,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.25,
    });
    let coPdpSubHeroImgAni = document.querySelectorAll(
      ".co--pdp--sub-hero--img--ani"
    );
    gsap.set(coPdpSubHeroImgAni, { scale: 0.75, yPercent: 25 });
    gsap.set(coPdpSubHeroImgAni[0], { xPercent: 25 });
    gsap.set(coPdpSubHeroImgAni[1], { xPercent: -25 });
    // gsap.set(coPdpSubHeroImgAni[2], {yPercent: 0});
    gsap.to(coPdpSubHeroImgAni, {
      scrollTrigger: {
        trigger: ".co--pdp--sub-hero",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      scale: 1,
      xPercent: 0,
      yPercent: 0,
      ease: "power2.out",
      stagger: 0.05,
    });
    gsap.to(".co--pdp--sub-hero--1--1--img", {
      scrollTrigger: {
        trigger: ".co--pdp--sub-hero",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: 5,
      xPercent: -2.5,
    });
    gsap.to(".co--pdp--sub-hero--1--2--img", {
      scrollTrigger: {
        trigger: ".co--pdp--sub-hero",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -5,
      xPercent: 2.5,
    });
    gsap.to(".co--pdp--sub-hero--1--3--img", {
      scrollTrigger: {
        trigger: ".co--pdp--sub-hero",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -2.5,
      scale: 1.1,
    });
    // ========================================================================================================================
    // PDP SLIDER
    // MARQUEE
    // change the speed
    let tickerSpeed = 1.4;
    let flickity = null;
    let isPaused = false;
    const slideshowEl = document.querySelector("#js-marquee");
    // functions
    const update = () => {
      if (isPaused) return;
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      window.requestAnimationFrame(update);
    };
    const pause = () => {
      isPaused = true;
    };
    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };
    //  create flickity
    flickity = new Flickity(slideshowEl, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
    flickity.x = 0;
    // event listeners
    // slideshowEl.addEventListener('mouseenter', pause, false);
    // slideshowEl.addEventListener('focusin', pause, false);
    // slideshowEl.addEventListener('mouseleave', play, false);
    // slideshowEl.addEventListener('focusout', play, false);
    // flickity.on('dragStart', () => {
    //   isPaused = true;
    // });
    // start
    update();
    // ===
    // ENTRY
    let coPdpSliderCopy = document.querySelectorAll(
      ".co--pdp--scroll-slider--1--1--copy"
    );
    gsap.set(coPdpSliderCopy[0], { yPercent: -100 });
    gsap.set(coPdpSliderCopy[1], { yPercent: 100 });
    gsap.to(coPdpSliderCopy, {
      scrollTrigger: {
        trigger: ".co--pdp--scroll-slider--1",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    // ===
    // let child = document.querySelector(`.box:nth-child(${1})`);
    let coPdpSliderCells = document.querySelectorAll(
      ".co--pdp--scroll-slider--2--cell"
    );
    gsap.set(coPdpSliderCells, { opacity: 0 });
    gsap.to(coPdpSliderCells, {
      scrollTrigger: {
        trigger: ".co--pdp--scroll-slider--2",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1.5,
      opacity: 1,
      // yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    // ========================================================================================================================
    // LARGE IMAGE
    gsap.set(".co--pdp--large-image--2--1", { opacity: 0, yPercent: 20 });
    gsap.to(".co--pdp--large-image--2--1", {
      scrollTrigger: {
        trigger: ".co--pdp--large-image",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      yPercent: 0,
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    gsap.set(".co--pdp--large-image--1--h2", { yPercent: -100 });
    gsap.to(".co--pdp--large-image--1--h2", {
      scrollTrigger: {
        trigger: ".co--pdp--large-image",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      yPercent: 0,
      duration: 1,
      ease: "power2.inOut",
    });
    gsap.to(".co--pdp--large-image--2--1--img", {
      scrollTrigger: {
        trigger: ".co--pdp--large-image",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-30%",
    });
    // ========================================================================================================================
    // TWO IMAGES
    gsap.to(".co--pdp--two-images--1--1--img", {
      scrollTrigger: {
        trigger: ".co--pdp--two-images",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-30%",
    });
    gsap.to(".co--pdp--two-images--2--1--img", {
      scrollTrigger: {
        trigger: ".co--pdp--two-images",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-30%",
    });
    // ===
    let coPdpTwoImages = document.querySelectorAll(".co--pdp--two-images-div");
    gsap.set(coPdpTwoImages, { opacity: 0 });
    gsap.to(coPdpTwoImages, {
      scrollTrigger: {
        trigger: ".co--pdp--two-images",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.2,
    });

    // ========================================================================================================================
    // ========================================================================================================================
    // ========================================================================================================================
    // COLLECTION
    // ========================================================================================================================
    // ========================================================================================================================
    // ========================================================================================================================
    // ========================================================================================================================
    // SUB HERO
    let coCollectionHeader = document.querySelectorAll(
      ".co--collection--header--ani"
    );
    gsap.set(coCollectionHeader, { yPercent: 100 });
    gsap.to(coCollectionHeader, {
      scrollTrigger: {
        trigger: ".co--collection--header",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    // COLLECTION
    // gsap.set('#ProductGridContainer', {opacity: 0});
    // gsap.to('#ProductGridContainer', {
    //     scrollTrigger: {
    //     trigger: "#ProductGridContainer",
    //     start: "top bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse"
    //   },
    //     duration: 1,
    //     opacity: 1,
    //     ease: "power2.inOut"
    // });
    // SUB HERO
    let coCollectionSubHero = document.querySelectorAll(
      ".co--collection--sub-hero--ani"
    );
    gsap.set(coCollectionSubHero, { yPercent: 100 });
    gsap.to(coCollectionSubHero, {
      scrollTrigger: {
        trigger: ".co--collection--sub-hero",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    // TWO BLOBS
    gsap.to(".co--collection--two-blobs--1--1--img", {
      scrollTrigger: {
        trigger: ".co--collection--two-blobs",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: 10,
      xPercent: -5,
      rotate: -5,
    });
    gsap.to(".co--collection--two-blobs--1--2--img", {
      scrollTrigger: {
        trigger: ".co--collection--two-blobs",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: -7,
      rotate: 5,
    });
    // Before After Drops MI Dev
    // gsap.to(".before_after_drop_right", {
    //   scrollTrigger: {
    //     trigger: ".before_after-content",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   yPercent: -10,
    //   rotate: 30,
    // });
    gsap.to(".before_after_drop_left", {
      scrollTrigger: {
        trigger: ".before_after-content",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-30%",
    });
    // gsap.to(".mobile_before_after_drop_right", {
    //   scrollTrigger: {
    //     trigger: ".before_after-content",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   xPercent: -10,
    //   rotate: 5,
    // });
    // gsap.to(".mobile_before_after_drop_left", {
    //   scrollTrigger: {
    //     trigger: ".before_after-content",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   xPercent: -10,
    //   rotate: 5,
    // });
    // gsap.to(".mobile_before_after_drop_bottom", {
    //   scrollTrigger: {
    //     trigger: ".before_after-content",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   yPercent: -10,
    //   rotate: 2.5,
    // });
    gsap.to(".before_after_drop_right", {
      scrollTrigger: {
        trigger: ".before_after_drop_right",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-30%",
    });
    gsap.to(".mobile_before_after_drop_left", {
      scrollTrigger: {
        trigger: ".mobile_before_after_drop_left",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "20%",
    });
    gsap.to(".mobile_before_after_drop_right", {
      scrollTrigger: {
        trigger: ".mobile_before_after_drop_right",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-20%",
    });
    gsap.to(".mobile_before_after_drop_bottom", {
      scrollTrigger: {
        trigger: ".mobile_before_after_drop_bottom",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-100px",
    });
    // REVIEWS
    let coCollectionSubHeroAni = document.querySelectorAll(
      ".co--collection--reviews--ani"
    );
    gsap.set(coCollectionSubHeroAni, { opacity: 0 });
    gsap.to(coCollectionSubHeroAni, {
      scrollTrigger: {
        trigger: ".co--collection--reviews",
        start: "25% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 0.75,
      opacity: 1,
      // ease: "power2.inOut",
      stagger: 0.05,
    });
    // ========================================================================================================================
    // ========================================================================================================================
    // CONCERNS
    // ========================================================================================================================
    // ========================================================================================================================
    // gsap.set(".co-plp-hero .co-ani-o", { opacity: 0 });
    // gsap.to(".co-plp-hero .co-ani-o", { 
    //   opacity: 1, 
    //   duration: 1,
    //   stagger: 0.1,
    //   ease: "Power2.inOut"
    // });
    // =======
    gsap.set(".co--concerns--hero", { opacity: 0 });
    gsap.to(".co--concerns--hero", {
      //   scrollTrigger: {
      //   trigger: ".co--concerns--hero",
      //   start: "1px top",
      //   end: "bottom top",
      //   toggleActions: "play none none none"
      // },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    gsap.set(".co--concerns--3-main-concerns-svg", { yPercent: 100 });
    gsap.to(".co--concerns--3-main-concerns-svg", {
      scrollTrigger: {
        trigger: ".co--concerns--hero",
        start: "1px top",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1.5,
      yPercent: 0,
      // delay: 0.5,
      ease: "power2.inOut",
    });
    gsap.to(".co--concerns--hero--1--2--img", {
      scrollTrigger: {
        trigger: ".co--concerns--hero",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.2,
    });
    let coConcernsSubHero1 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani"
    );
    gsap.set(coConcernsSubHero1, { yPercent: 100 });
    gsap.to(coConcernsSubHero1, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero",
        start: "5% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      yPercent: 0,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    let coConcernsSubHero2 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani-2"
    );
    gsap.set(coConcernsSubHero2, { opacity: 0 });
    gsap.to(coConcernsSubHero2, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--2",
        start: "5% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--2--2--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-10%",
    });
    let coConcernsSubHero3 = document.querySelectorAll(
      ".co--concerns--sub-hero--ani-3"
    );
    gsap.set(coConcernsSubHero3, { opacity: 0 });
    gsap.to(coConcernsSubHero3, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--3--2",
        start: "15% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--3--1--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--3",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      bottom: "-20%",
    });
    let coConcernsSubHero4 = document.querySelectorAll(
      ".co--concerns--sub-hero--tail--ani"
    );
    gsap.set(coConcernsSubHero4, { opacity: 0 });
    gsap.to(coConcernsSubHero4, {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--tail",
        start: "15% bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.1,
    });
    gsap.to(".co--concerns--sub-hero--tail--1--2--1--1--img", {
      scrollTrigger: {
        trigger: ".co--concerns--sub-hero--tail",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      top: "-20%",
    });
    gsap.set(".co--concerns--gifs", { opacity: 0 });
    gsap.to(".co--concerns--gifs", {
      scrollTrigger: {
        trigger: ".co--concerns--gifs",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // =========
    gsap.set(".co-plp-s-faq .co-ani-o", { opacity: 0, y: 20 });
    gsap.to(".co-plp-s-faq .co-ani-o", { 
      scrollTrigger: {
        trigger: ".co-plp-s-faq",
        start: "25% bottom",
        end: "bottom top"
      },
      opacity: 1, 
      y: 0,
      duration: 1,
      stagger: 0.1,
      ease: "Power2.inOut"
    });
    // ========================================================================================================================
    // ========================================================================================================================
    // FAQ
    // ========================================================================================================================
    // ========================================================================================================================
    gsap.set(".co--faq--hero", { opacity: 0 });
    gsap.to(".co--faq--hero", {
      scrollTrigger: {
        trigger: ".co--faq--hero",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    // ========================================================================================================================
    // ========================================================================================================================
    // CLINIC
    // ========================================================================================================================
    // ========================================================================================================================
    // gsap.set(".co--clinic--hero", { opacity: 0 });
    // gsap.to(".co--clinic--hero", {
    //   scrollTrigger: {
    //     trigger: ".co--faq--hero",
    //     start: "top bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse",
    //   },
    //   duration: 1,
    //   opacity: 1,
    //   ease: "power2.inOut",
    // });
    // let coClinicHeroTextAni = document.querySelectorAll(
    //   ".co--clinic--hero--text-ani"
    // );
    // gsap.set(coClinicHeroTextAni, { yPercent: 100 });
    // gsap.to(coClinicHeroTextAni, {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse",
    //   },
    //   duration: 1,
    //   yPercent: 0,
    //   ease: "power2.inOut",
    //   stagger: 0.25,
    // });
    // gsap.to(".co--clinic--hero--1--1--1--1", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   yPercent: 15,
    // });
    // gsap.to(".co--clinic--hero--1--1--1--2", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   xPercent: 5,
    //   yPercent: 5,
    // });
    // gsap.to(".co--clinic--hero--1--blog", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   yPercent: -20,
    //   xPercent: 2.5,
    // });
    // gsap.to(".co--clinic--hero--1--1--1--1--img", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   scale: 1.2,
    // });
    // gsap.to(".co--clinic--hero--1--1--1--2--img", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero",
    //     start: "top top",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   scale: 1.1,
    // });
    // // HERO
    // gsap.set(".co--clinic--hero--1--2--svg", { yPercent: 100 });
    // gsap.to(".co--clinic--hero--1--2--svg", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--hero--1--2",
    //     start: "top bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse",
    //   },
    //   duration: 1,
    //   yPercent: 0,
    //   ease: "power2.inOut",
    // });

    // let coClinicTimeAni2 = gsap.timeline();
    // coClinicTimeAni2.fromTo(
    //   ".co--clinic--hero--1--3--1--span",
    //   {
    //     xPercent: 100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     xPercent: 0,
    //     duration: 1,
    //   }
    // );
    // coClinicTimeAni2.fromTo(
    //   ".co--clinic--hero--1--3--1--1",
    //   {
    //     yPercent: -100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     yPercent: 0,
    //     duration: 1,
    //   },
    //   "-=0.5"
    // );
    // coClinicTimeAni2.fromTo(
    //   ".co--clinic--hero--1--3--1--2",
    //   {
    //     yPercent: 100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     yPercent: 0,
    //     duration: 1.5,
    //   },
    //   "-=1"
    // );
    // // ==========
    // ScrollTrigger.create({
    //   trigger: ".co--clinic--hero--1--3",
    //   toggleActions: "restart none none reverse",
    //   start: "bottom bottom",
    //   end: "top top",
    //   // markers: true,
    //   animation: coClinicTimeAni2,
    // });

    // // HERO
    // let coClinicTimeAni3 = gsap.timeline();
    // coClinicTimeAni3.fromTo(
    //   ".co--clinic--pact--3--1--span",
    //   {
    //     xPercent: 100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     xPercent: 0,
    //     duration: 1,
    //   }
    // );
    // coClinicTimeAni3.fromTo(
    //   ".co--clinic--pact--3--1--1",
    //   {
    //     yPercent: -100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     yPercent: 0,
    //     duration: 1,
    //   },
    //   "-=0.5"
    // );
    // coClinicTimeAni3.fromTo(
    //   ".co--clinic--pact--3--1--2",
    //   {
    //     yPercent: 100,
    //   },
    //   {
    //     ease: "power2.inOut",
    //     yPercent: 0,
    //     duration: 1.5,
    //   },
    //   "-=1"
    // );
    // // ==========
    // ScrollTrigger.create({
    //   trigger: ".co--clinic--pact--3",
    //   toggleActions: "restart none none reverse",
    //   start: "bottom bottom",
    //   end: "top top",
    //   // markers: true,
    //   animation: coClinicTimeAni3,
    // });
    // let coClinicPactTextAni = document.querySelectorAll(
    //   ".co--clinic--pact--text-ani"
    // );
    // gsap.set(coClinicPactTextAni, { yPercent: 100 });
    // gsap.to(coClinicPactTextAni, {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--pact",
    //     start: "top bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse",
    //   },
    //   duration: 1,
    //   yPercent: 0,
    //   ease: "power2.inOut",
    //   stagger: 0.25,
    // });
    // // REVIEWS
    // let coClinicReviewsTextAni = document.querySelectorAll(
    //   ".co--clinic--yelp-reviews--ani"
    // );
    // gsap.set(coClinicReviewsTextAni, { opacity: 0 });
    // gsap.to(coClinicReviewsTextAni, {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--yelp-reviews",
    //     start: "25% bottom",
    //     end: "bottom top",
    //     toggleActions: "play none none reverse",
    //   },
    //   duration: 0.75,
    //   opacity: 1,
    //   // ease: "power2.inOut",
    //   stagger: 0.05,
    // });
    // gsap.to(".co--clinic--yelp-reviews--1--2", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--yelp-reviews",
    //     start: "50% bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   yPercent: -10,
    // });
    // gsap.to(".co--clinic--two-images--1--1--img", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--two-images",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   bottom: "-20%",
    // });
    // gsap.to(".co--clinic--two-images--2--1--img", {
    //   scrollTrigger: {
    //     trigger: ".co--clinic--two-images",
    //     start: "top bottom",
    //     end: "bottom top",
    //     scrub: true,
    //   },
    //   top: "-20%",
    // });




    // ========================================================================================================================
    // ========================================================================================================================
    // ACNE TYPES
    // ========================================================================================================================
    // ========================================================================================================================
    gsap.set(".co-acne-1", { opacity: 0 });
    gsap.to(".co-acne-1", {
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.to(".co-acne-1-blob-2", {
        scrollTrigger: {
        trigger: ".co-acne-1",
        start: "top top",
        end: "bottom top",
        scrub: true
      },
      x: -80,
      y: 140,
      rotateZ: "20deg"
    });
    gsap.to(".co-acne-1-blob-1>div", {
        scrollTrigger: {
        trigger: ".co-acne-1",
        start: "top top",
        end: "bottom top",
        scrub: true
      },
      x: 60,
      y: -100,
      rotateZ: "-30deg"
    });
    // 2
    gsap.set(".co-acne-2-top-image", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-top-image", {
        scrollTrigger: {
        trigger: ".co-acne-2-top-image",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.set(".co-acne-2-ani", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-ani", {
        scrollTrigger: {
        trigger: ".co-acne-2-top-left-frame",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut",
      stagger: 0.1
    });
    gsap.to(".co-acne-2-top-image>div", {
      scrollTrigger: {
        trigger: ".co-acne-2-top-image",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "-10%"
    });
    // 3
    gsap.set(".co-acne-2-bottom-image", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-bottom-image", {
        scrollTrigger: {
        trigger: ".co-acne-2-bottom-image",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    });
    gsap.set(".co-acne-2-ani-bot", { opacity: 0, y: 20 });
    gsap.to(".co-acne-2-ani-bot", {
        scrollTrigger: {
        trigger: ".co-acne-2-bottom-left-frame",
        start: "top 90%",
        end: "bottom top",
      },
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut",
      stagger: 0.1
    });
    gsap.to(".co-acne-2-bottom-image>div", {
      scrollTrigger: {
        trigger: ".co-acne-2-bottom-image",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "-10%"
    });
    // pin
    (function () {
  gsap.registerPlugin(ScrollTrigger);

  let st = null;

  function initDynamicPin(selector = ".co-acne-2-top") {
    const el = document.querySelector(selector);
    if (!el) return;

    function createDynamicPin() {
      if (st) st.kill();

      const isTallerThanViewport = el.offsetHeight > window.innerHeight;

      st = ScrollTrigger.create({
        trigger: el,
        start: isTallerThanViewport ? "bottom bottom" : "top top",
        end: "bottom top",
        pin: true,
        pinSpacing: false
      });
    }

    createDynamicPin();

    ScrollTrigger.addEventListener("refreshInit", createDynamicPin);
    ScrollTrigger.refresh();
  }

  // Auto-init
  initDynamicPin();
})();

    // 3
    gsap.to(".co-acne-3-blob-1-frame>div", {
        scrollTrigger: {
        trigger: ".co-acne-3",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: -50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-3", { opacity: 0 });
    gsap.to(".co-acne-3", {
        scrollTrigger: {
        trigger: ".co-acne-3-tabs-navigation",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      duration: 1,
      ease: "Power2.inOut"
    }); 
    gsap.set(".co-acne-3-tabs-button>div", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-3-tabs-button>div", {
        scrollTrigger: {
        trigger: ".co-acne-3-tabs-navigation",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut",
      stagger: 0.2
    });
    // 4
    gsap.to(".co-acne-4-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-4",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: 50,
      rotateZ: "10"
    });
    gsap.set(".co-acne-4-left", { x: -30, transition: "0s" });
    gsap.to(".co-acne-4-left", {
        scrollTrigger: {
        trigger: ".co-acne-4-left",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      x: 0,
      duration: 0.75,
      ease: "Power4.inOut"
    });
    gsap.set(".co-acne-4-right", { opacity: 0, x: 30, transition: "0s" });
    gsap.to(".co-acne-4-right", {
        scrollTrigger: {
        trigger: ".co-acne-4-right",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      x: 0,
      duration: 0.75,
      ease: "Power4.inOut"
    });
    // 5
    gsap.to(".co-acne-5-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-5",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -50,
      x: -50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-5-frame", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-5-frame", {
        scrollTrigger: {
        trigger: ".co-acne-5-frame",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    // 6
    gsap.to(".co-acne-6-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -75,
      x: -50,
      rotateZ: "10"
    });
    gsap.to(".co-acne-6-blob-2-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -75,
      x: 30,
      rotateZ: "-10"
    });
    gsap.to(".co-acne-6-blob-3-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: -105,
      x: -30,
      rotateZ: "10"
    });
    gsap.to(".co-acne-6-blob-4-frame", {
        scrollTrigger: {
        trigger: ".co-acne-6",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: 50,
      rotateZ: "-10"
    });
    gsap.set(".co-acne-6-content", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-6-content", {
        scrollTrigger: {
        trigger: ".co-acne-6-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    // 7
    gsap.set(".co-acne-7-content", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-7-content", {
        scrollTrigger: {
        trigger: ".co-acne-7-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut"
    });
    gsap.to(".co-acne-7-right-image", {
        scrollTrigger: {
        trigger: ".co-acne-7-right",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      top: "5%"
    });
    gsap.to(".co-acne-8-blob-1-frame", {
        scrollTrigger: {
        trigger: ".co-acne-8-blob-1",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: 50,
      rotateZ: "-10"
    });
    gsap.to(".co-acne-8-blob-2-frame", {
        scrollTrigger: {
        trigger: ".co-acne-8-blob-2",
        start: "top bottom",
        end: "bottom top",
        scrub: true
      },
      y: 45,
      x: -70,
      rotateZ: "10"
    });
    gsap.set(".co-acne-8-ani", { opacity: 0, y: 30, transition: "0s" });
    gsap.to(".co-acne-8-ani", {
        scrollTrigger: {
        trigger: ".co-acne-8-content",
        start: "top 90%",
        end: "bottom top",
      },
      opacity: 1,
      y: 0,
      duration: 0.75,
      ease: "Power3.inOut",
      stagger: 0.2
    });





    // ========================================================================================================================
    // ========================================================================================================================
    // OUR STORY
    // ========================================================================================================================
    // ========================================================================================================================
    gsap.set(".co--our-story--hero", { opacity: 0 });
    gsap.to(".co--our-story--hero", {
      scrollTrigger: {
        trigger: ".co--our-story--hero",
        start: "top 5%",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
    });
    let coOurStoryHeroTextAni = document.querySelectorAll(
      ".co--our-story--hero--text-ani"
    );
    gsap.set(coOurStoryHeroTextAni, { opacity: 0 });
    gsap.to(coOurStoryHeroTextAni, {
      scrollTrigger: {
        trigger: ".co--our-story--hero",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    gsap.to(".co--our-story--hero--2--2--1--img", {
      scrollTrigger: {
        trigger: ".co--our-story--hero--2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.1,
    });
    gsap.to(".co--our-story--hero--2--2--2--img", {
      scrollTrigger: {
        trigger: ".co--our-story--hero--2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      yPercent: 10,
    });
    gsap.to(".co--our-story--hero--1--1--img", {
      scrollTrigger: {
        trigger: ".co--our-story--hero",
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.1,
    });
    let coOurStoryHeroTextAni2 = document.querySelectorAll(
      ".co--our-story--hero--text-ani-2"
    );
    gsap.set(coOurStoryHeroTextAni2, { opacity: 0 });
    gsap.to(coOurStoryHeroTextAni2, {
      scrollTrigger: {
        trigger: ".co--our-story--hero--2",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.2,
    });
    // IMPACT
    gsap.to(".co--our-story--earth--1--2--img", {
      scrollTrigger: {
        trigger: ".co--our-story--earth",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.1,
    });
    gsap.to(".co--our-story--earth--1--2--img", {
      scrollTrigger: {
        trigger: ".co--our-story--earth",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.1,
    });
    gsap.to(".co--our-story--earth--1--2 img", {
      scrollTrigger: {
        trigger: ".co--our-story--earth--1--2",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      scale: 1.05
    });
    gsap.set(".co--our-story--earth--1--2", { opacity: 0, y: 20 });
    gsap.to(".co--our-story--earth--1--2", {
      scrollTrigger: {
        trigger: ".co--our-story--earth--1--2",
        start: "top 90%",
        end: "bottom top"
      },
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "Power2.inOut"
    });
    let coOurStoryEarthTextAni = document.querySelectorAll(
      ".co--our-story--earth--text-ani"
    );
    gsap.set(coOurStoryEarthTextAni, { opacity: 0 });
    gsap.to(coOurStoryEarthTextAni, {
      scrollTrigger: {
        trigger: ".co--our-story--earth",
        start: "top bottom",
        end: "bottom top",
        toggleActions: "play none none reverse",
      },
      duration: 1,
      opacity: 1,
      ease: "power2.inOut",
      stagger: 0.2,
    });


    

    // ========================================================================================================================
    /* === I 111 === */
  });
  /* === X 111 === */
  /* === I 222 === */
  // };
  /* === X 222 === */
  /* === I 333 === */
});
/* === X 333 === */













